export interface Translation {
  language: string;
  text: string;
  subject?: string;
}
